export function processStepsHover() {
  const menuItems = document.querySelectorAll(".feature-item");
  let lastHoveredElement = null;

  menuItems.forEach((menuItem) => {
    menuItem.addEventListener("mouseover", () => {
      if (lastHoveredElement) {
        lastHoveredElement.classList.remove("active");
      }

      menuItem.classList.add("active");

      lastHoveredElement = menuItem;
    });

    menuItem.addEventListener("mouseout", () => {
      menuItems.forEach((item) => {
        if (item !== lastHoveredElement) {
          item.classList.remove("active");
        }
      });
    });
  });
}
